import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import styled from 'styled-components';

// import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import Paper from '@material-ui/core/Paper';
import { Alert, AlertTitle } from '@material-ui/lab';
import CircularProgress from '@material-ui/core/CircularProgress';

import { confirmRegistration } from '../../services/Register';

const MainContainer = styled(Paper)`
    width: 500px;
    max-width: 100%;
    padding: 16px;
`;

const StyledAlert = styled(Alert)`
    margin-bottom: 16px;
`;

const STATUS_INITIAL = 0;
const STATUS_SUBMITTING = 1;
const STATUS_SUCCES = 2;
const STATUS_FAILED = 3;

const RegistrationConfirmation = () => {
    const { t } = useTranslation();
    const [status, setStatus] = useState(STATUS_INITIAL);

    // const { enqueueSnackbar } = useSnackbar();

    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const token = query.get('token');

    useEffect(() => {
        if (token) {
            setStatus(STATUS_SUBMITTING);
            confirmRegistration(token)
                .then((registerResult) => {
                    setStatus(STATUS_SUCCES);
                })
                .catch((err) => {
                    console.warn('err:', err);
                    setStatus(STATUS_FAILED);
                });
        }
    }, [token]);

    let alert = null;
    if (!token) {
        alert = (
            <Alert severity="error">
                <AlertTitle>{t('error.urlNotComplete')}</AlertTitle>
                {t('error.missingToken')}
            </Alert>
        );
    } else if (status === STATUS_SUBMITTING) {
        alert = <CircularProgress />;
    } else if (status === STATUS_SUCCES) {
        alert = (
            <Alert severity="success">
                <AlertTitle>
                    {t('register.registrationConfirmed.title')}
                </AlertTitle>
                {t('register.registrationConfirmed.content')}
            </Alert>
        );
    } else if (status === STATUS_FAILED) {
        alert = (
            <StyledAlert severity="error">
                <AlertTitle>{t('error.registrationFailed')}</AlertTitle>
                {t('error.errorWhileRegistration')}
            </StyledAlert>
        );
    }
    return <MainContainer>{alert}</MainContainer>;
};

export default RegistrationConfirmation;
